'use es6';

import PropTypes from 'prop-types';
import unescapedText from 'I18n/utils/unescapedText';
import { Flex } from 'foundations-components/components/Flex';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { RightIcon, DownIcon } from 'foundations-assets';
import withConnectedMenuLabel from 'simple-menus-lib/components/menu/decorators/withConnectedMenuLabel';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CollapseButton = ({
  hasChildren,
  isCollapsed,
  toggleCollapse
}) => {
  if (hasChildren) {
    return /*#__PURE__*/_jsx(IconButton, {
      use: "transparent",
      onClick: toggleCollapse,
      size: "small",
      children: isCollapsed ? /*#__PURE__*/_jsx(RightIcon, {}) : /*#__PURE__*/_jsx(DownIcon, {})
    });
  }
  return null;
};
function MenuItemLabel({
  hasChildren,
  isCollapsed,
  toggleCollapse,
  label = '',
  onLabelChange,
  readOnly
}) {
  return /*#__PURE__*/_jsx("div", {
    draggable: true,
    onDragStart: e => {
      // When trying to highlight text prevent the entire component from dragging
      e.preventDefault();
      e.stopPropagation();
    },
    children: /*#__PURE__*/_jsxs(Flex, {
      flexGrow: 1,
      children: [/*#__PURE__*/_jsx(CollapseButton, {
        hasChildren: hasChildren,
        isCollapsed: isCollapsed,
        toggleCollapse: toggleCollapse
      }), /*#__PURE__*/_jsx(TextInput, {
        "data-test-id": "menu-label",
        defaultValue: label,
        onChange: onLabelChange,
        placeholder: unescapedText('simpleMenusLib.components.menuItemLabel.placeholder'),
        disabled: readOnly
      })]
    })
  });
}
MenuItemLabel.propTypes = {
  toggleCollapse: PropTypes.func.isRequired,
  hasChildren: PropTypes.bool.isRequired,
  isCollapsed: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool,
  /* Connect */
  label: PropTypes.string.isRequired,
  onLabelChange: PropTypes.func.isRequired
};
export default withConnectedMenuLabel()(MenuItemLabel);